<template>
    <Modal class="popup_content" v-model="remarkshow" width="560" @on-cancel="remarksCancel">
        <div slot="header" class="popup_header_content">
            <span>商品备注</span>
        </div>
        <div class="popup_head_body">
            <Input v-model="remarksInfos" type="textarea" :rows="8" placeholder="请输入备注内容" :autofocus="true" />
        </div>
        <div slot="footer" class="popup_footer_content">
            <Button type="warning" size="large" @click="remarksOk">提交</Button>
        </div>
    </Modal>
</template>

<script>
    export default {
        props: ['remarksShow', 'remarksInfo'],
        data() {
            return {
                remarkshow: false,
                remarksInfos: ''
            }
        },
        methods: {
            remarksOk () {
                this.remarkshow = false
                this.$emit('remarksOk', this.remarksInfos)
            },
            remarksCancel () {
                this.remarkshow = false
                this.$emit('remarksCancel')
            }
        },
        watch: {
            remarksShow () {
                this.remarkshow = this.remarksShow
                this.remarksInfos = this.remarksInfo
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/component/popup/remarks.vue